import { z } from "zod";

import { api } from "@/redux/api";

const listRerunApi = api.injectEndpoints({
	endpoints: (builder) => ({
		rerunList: builder.mutation<{ success: boolean }, number>({
			query: (id) => ({
				url: `list/rerun/${id}`,
				method: "POST",
				responseSchema: z.object({ success: z.boolean() }),
			}),
			invalidatesTags: ["List"],
		}),
	}),
});

export const { useRerunListMutation } = listRerunApi;
